import { cn as e } from "../shared/utils.js";
import { useTranslation as t } from "../i18n/hooks.js";
import { useCodeMirrorHost as n } from "./use-code-mirror-host.js";
import { DEFAULT_FIELD_ERROR_MESSAGE as r, FIELD_ERROR_LOCO_KEY as i } from "./validation/catalog.js";
import { useTrackingCodeValidation as a } from "./use-tracking-code-validation.js";
import { createContext as o, forwardRef as s, useCallback as c, useContext as l, useEffect as u, useId as d, useMemo as f, useRef as p, useState as m } from "react";
import { jsx as h } from "react/jsx-runtime";
//#region src/tracking-code-input/tracking-code-input.tsx
var g = o(null);
function _(e) {
	let t = l(g);
	if (!t) throw Error(`TrackingCodeInput.${e} must be used within TrackingCodeInput.Root`);
	return t;
}
function v(e, t) {
	typeof e == "function" ? e(t) : e && (e.current = t);
}
var y = s(({ className: t, children: n, value: r, defaultValue: i = "", onValueChange: o, diagnostics: s, builtInValidation: l = !0, messageOverrides: u, invalid: p, onValidationChange: _, readOnly: v = !1, id: y, ...b }, x) => {
	let S = r !== void 0, [C, w] = m(i), T = S ? r : C, E = d(), D = y ? `${y}-control` : `${E}-control`, O = y ? `${y}-description` : `${E}-description`, k = y ? `${y}-error` : `${E}-error`, [A, j] = m({}), M = c((e, t) => (j((n) => n[e] === t ? n : {
		...n,
		[e]: t
	}), () => {
		j((t) => {
			if (t[e] === void 0) return t;
			let n = { ...t };
			return delete n[e], n;
		});
	}), []), N = f(() => {
		let e = [A.description, A.error].filter((e) => !!e);
		return e.length > 0 ? e.join(" ") : void 0;
	}, [A.description, A.error]), P = c((e) => {
		S || w(e), o?.(e);
	}, [S, o]), F = a({
		value: T,
		builtInValidation: l,
		diagnostics: s,
		messageOverrides: u,
		onValidationChange: _
	}), I = p === void 0 ? !F.valid : p, L = f(() => ({
		value: T,
		setValue: P,
		controlId: D,
		descriptionId: O,
		errorId: k,
		ariaDescribedBy: N,
		registerDescribedBy: M,
		isInvalid: I,
		diagnostics: F.diagnostics,
		readOnly: v
	}), [
		N,
		D,
		T,
		O,
		k,
		I,
		v,
		M,
		P,
		F.diagnostics
	]);
	return /* @__PURE__ */ h(g.Provider, {
		value: L,
		children: /* @__PURE__ */ h("div", {
			ref: x,
			id: y,
			"data-slot": "tracking-code-input",
			"data-testid": "tracking-code-input",
			className: e("grid w-full gap-2", t),
			...b,
			children: n
		})
	});
});
y.displayName = "TrackingCodeInput.Root";
var b = s(({ className: t, ...n }, r) => {
	let { controlId: i } = _("Label");
	return /* @__PURE__ */ h("label", {
		ref: r,
		htmlFor: i,
		"data-slot": "tracking-code-input-label",
		"data-testid": "tracking-code-input-label",
		className: e("text-text-secondary text-base font-normal", t),
		...n
	});
});
b.displayName = "TrackingCodeInput.Label";
var x = s(({ className: t, id: r, onFocus: i, ...a }, o) => {
	let { value: s, setValue: l, controlId: u, isInvalid: d, diagnostics: f, ariaDescribedBy: m, readOnly: g } = _("Control"), y = p(null), b = n({
		hostRef: y,
		value: s,
		onValueChange: l,
		diagnostics: f,
		readOnly: g
	}), x = c((e) => {
		y.current = e, v(o, e);
	}, [o]);
	return /* @__PURE__ */ h("div", {
		ref: x,
		id: r ?? u,
		"data-slot": "tracking-code-input-control",
		"data-testid": "tracking-code-input-control",
		"data-invalid": d || void 0,
		"data-readonly": g || void 0,
		"aria-invalid": d || void 0,
		"aria-readonly": g || void 0,
		"aria-describedby": m,
		tabIndex: -1,
		className: e("relative w-full overflow-hidden rounded-md outline-none", "bg-bg-primary", "[--tracking-code-row-height:28px]", "[--tracking-code-gutter-width:41px]", "[--tracking-code-min-height:336px]", "min-h-(--tracking-code-min-height)", "after:pointer-events-none after:absolute after:inset-0 after:z-20 after:rounded-[inherit] after:content-['']", d ? "after:shadow-[inset_0_0_0_2px_var(--color-field-border-error)]" : "after:shadow-[inset_0_0_0_1px_var(--color-field-border)]", t),
		onFocus: (e) => {
			i?.(e), e.target === y.current && b.current?.focus();
		},
		...a
	});
});
x.displayName = "TrackingCodeInput.Control";
var S = s(({ className: t, id: n, ...r }, i) => {
	let { descriptionId: a, registerDescribedBy: o } = _("Description"), s = n ?? a;
	return u(() => o("description", s), [o, s]), /* @__PURE__ */ h("p", {
		ref: i,
		id: s,
		"data-slot": "tracking-code-input-description",
		"data-testid": "tracking-code-input-description",
		className: e("text-text-tertiary text-base", t),
		...r
	});
});
S.displayName = "TrackingCodeInput.Description";
var C = s(({ className: n, children: a, id: o, ...s }, c) => {
	let { t: l } = t(), { isInvalid: d, errorId: f, registerDescribedBy: p } = _("Error"), m = o ?? f, g = l(i, { defaultValue: r });
	return u(() => {
		if (d) return p("error", m);
	}, [
		d,
		p,
		m
	]), d ? /* @__PURE__ */ h("p", {
		ref: c,
		id: m,
		"data-slot": "tracking-code-input-error",
		"data-testid": "tracking-code-input-error",
		role: "alert",
		className: e("text-text-error text-base", n),
		...s,
		children: a ?? g
	}) : null;
});
C.displayName = "TrackingCodeInput.Error";
var w = {
	Root: y,
	Control: x,
	Label: b,
	Description: S,
	Error: C
};
//#endregion
export { w as TrackingCodeInput };
